var stripAnsi = require('strip-ansi')
var wcwidth = require('wcwidth')

module.exports = function(str) {
  return wcwidth(stripAnsi(str))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/columnify/width.js
// module id = /4D2
// module chunks = 0